export default "__VITE_ASSET__Z0T7pvyI__"